export default __webpack_public_path__ + "static/media/img3.e9f10a8c.svg";